// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpFilterPanel .bdp-sticky-header {
  position: sticky;
  top: 42px;
  z-index: 100;
  background: #fff;
  padding: 10px 0px;
}
#bdpFilterPanel ::ng-deep .custom-vertical-divider .p-divider.p-divider-vertical {
  color: 1px solid rgb(14, 13, 13) !important;
}
#bdpFilterPanel .sidebar-header {
  display: inline-block;
  border-bottom: thin solid #a8a8a8;
  padding-bottom: 20px;
  margin-bottom: 12px;
  color: #dcdcdc;
  width: 100%;
}
#bdpFilterPanel .sidebar-header h5 {
  float: left;
  margin: 0;
  line-height: 2;
  color: var(--bdpFontPrimary);
  font-size: 16px;
}
#bdpFilterPanel .sidebar-header .bdp-clear-filters {
  display: block;
  padding: 8px 0 0 10px;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  float: right;
}
#bdpFilterPanel .sidebar-header .bdp-filter-close {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  float: right;
  position: relative;
  top: 5px;
  color: var(--bdpButtonPrimary);
  font-size: 23px;
  cursor: pointer;
}
#bdpFilterPanel .sidebar-header .sidebar-button {
  float: right;
  margin: 0px 15px;
  position: relative;
}
#bdpFilterPanel .sidebar-header .sidebar-button ::ng-deep button {
  background-color: var(--bdpButtonPrimary);
  border: none;
}
#bdpFilterPanel ::ng-deep {
  /* Fix for p-multiSelect dropdown positioning and overlap */
  /* Fix for the p-multiSelect input label */
  /* Ensure the multiselect component itself doesn't overflow */
}
#bdpFilterPanel ::ng-deep .p-sidebar-right {
  overflow-y: scroll;
}
#bdpFilterPanel ::ng-deep .p-sidebar-content {
  overflow-y: initial !important;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options {
  float: left;
  width: 100%;
  position: relative;
  margin-bottom: 10px;
  padding-top: 3px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-ini-view {
  float: left;
  width: 100%;
  margin-bottom: 15px;
  display: inline-block;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-ini-view .sidebar-button {
  width: 86%;
  float: left;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-ini-view .sidebar-button button {
  background: #fff;
  color: #444;
  border-color: rgba(68, 68, 68, 0.2666666667);
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-ini-view .bdp-setting-icon {
  padding: 5px 0px 5px 10px;
  font-size: 20px;
  float: right;
  cursor: pointer;
  color: #004ce1;
  font-weight: bold;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options p-card {
  float: left;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options p-card .p-card-body {
  padding: 0px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options p-card .p-card-body .p-card-content {
  padding: 1rem;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .sidebar-button {
  float: left;
  width: 123px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .sidebar-button.bdp-save-filter {
  margin-left: 10px;
  background-color: #2d74ff;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .sidebar-button.bdp-cancle {
  margin-right: 10px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .sidebar-button.bdp-cancle button {
  background-color: #fff;
  border-color: #3e5172;
  color: #3e5172;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list {
  padding: 0px 10px;
  list-style-type: none;
  display: inline-block;
  width: 100%;
  margin: 0px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li {
  margin: 5px 0px;
  display: inline-block;
  width: 100%;
  padding: 5px 5px 0px 5px;
  border-radius: 3px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li:hover {
  background-color: rgba(232, 241, 248, 0.7);
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li.bdp-selected {
  background-color: #004ce1;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li.bdp-selected span {
  color: #fff;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li.bdp-selected i {
  color: #fff;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li h6 {
  margin-bottom: 5px;
  font-size: 14px;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li span {
  display: inline-block;
  width: 150px;
  color: #333;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-saved-filter-list li i {
  float: right;
  cursor: pointer;
  padding: 5px;
  color: #333;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-filter-info {
  border-top: 2px solid #ccd;
  display: inline-block;
  padding: 5px;
  margin-top: 15px;
  color: #828282;
  text-align: center;
}
#bdpFilterPanel ::ng-deep .bdp-filter-options .bdp-filter-view .bdp-filter-info a {
  color: #2d74ff;
  text-decoration: underline;
  cursor: pointer;
}
#bdpFilterPanel ::ng-deep .p-multiselect-panel {
  z-index: 10002 !important; /* Ensure it appears above other elements */
  min-width: 100% !important; /* Match the width of the parent */
  max-width: 100% !important; /* Restrict to parent width to prevent overflow */
  right: 0 !important; /* Align to the right edge of the parent */
  left: auto !important; /* Prevent stretching across the screen */
  top: 100% !important; /* Position below the input */
  transform-origin: top right; /* Ensure proper dropdown positioning */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* Add shadow for visibility */
  overflow: hidden; /* Prevent content from overflowing */
}
#bdpFilterPanel ::ng-deep .p-multiselect-items-wrapper {
  max-height: 200px !important; /* Limit dropdown height */
  overflow-y: auto !important; /* Enable scrolling for long lists */
  width: 100% !important; /* Match the panel width */
  box-sizing: border-box; /* Ensure padding/border are included in width */
}
#bdpFilterPanel ::ng-deep .p-multiselect-items {
  padding: 0 !important; /* Remove default padding */
  width: 100% !important; /* Ensure items take full width */
  box-sizing: border-box; /* Ensure padding/border are included in width */
}
#bdpFilterPanel ::ng-deep .p-multiselect-item {
  white-space: normal !important; /* Allow text to wrap */
  padding: 8px 12px !important; /* Add padding for readability */
  font-size: 14px !important; /* Adjust font size */
  line-height: 1.5 !important; /* Improve line spacing */
  text-transform: none !important; /* Remove uppercase transform */
  word-break: break-word !important; /* Ensure long words break properly */
  width: 100% !important; /* Ensure items take full width */
  box-sizing: border-box; /* Prevent padding from causing overflow */
}
#bdpFilterPanel ::ng-deep .p-multiselect-label {
  white-space: normal !important; /* Allow placeholder text to wrap */
  padding: 8px !important; /* Add padding to prevent truncation */
  font-size: 14px !important; /* Match font size */
  width: 100% !important; /* Ensure label takes full width */
  box-sizing: border-box; /* Prevent padding from causing overflow */
}
#bdpFilterPanel ::ng-deep .p-multiselect {
  width: 100% !important; /* Ensure the component takes full width */
  max-width: 100% !important; /* Prevent overflow */
  box-sizing: border-box; /* Include padding/border in width */
}
#bdpFilterPanel ::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-option {
  white-space: nowrap !important; /* Override the previous rule */
}
#bdpFilterPanel .bdp-separator {
  width: 100%;
  height: 0px;
  margin: 20px 0px 0px 0px;
  border-top: 1px solid #ccc;
  padding: 0px;
}
#bdpFilterPanel .sidebar-cat-header {
  font-size: 14px;
  font-weight: bold;
}
#bdpFilterPanel .sidebar-cat-header h6 {
  margin-bottom: 12px;
}
#bdpFilterPanel .bdp-clear-select {
  position: absolute;
  right: 28px;
  top: 32px;
  z-index: 1;
  cursor: pointer;
}
#bdpFilterPanel .bdp-clear-select i {
  font-size: 11px;
}
#bdpFilterPanel .bdp-filter-wrapper {
  padding: 0 10px; /* Add padding to ensure content stays within bounds */
  box-sizing: border-box; /* Ensure padding is included in width */
}
#bdpFilterPanel .bdp-filter-wrapper .p-field,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters {
  position: relative;
  float: left;
  width: 100%;
  display: block;
  margin-bottom: 20px; /* Add spacing between fields */
  box-sizing: border-box; /* Prevent overflow */
  padding: 0 5px; /* Add padding to ensure content fits */
}
#bdpFilterPanel .bdp-filter-wrapper .p-field label,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters label {
  color: #1d2125;
  font-size: 14px;
  margin-bottom: 8px;
  white-space: normal !important; /* Ensure label text wraps */
  display: block; /* Ensure label takes full width */
  line-height: 1.5; /* Improve readability */
  width: 100%; /* Ensure label takes full width */
  box-sizing: border-box; /* Prevent padding from causing overflow */
  padding-right: 10px; /* Add padding to ensure full text visibility */
}
#bdpFilterPanel .bdp-filter-wrapper .p-field .bdp-radio-group .p-field-radiobutton,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters .bdp-radio-group .p-field-radiobutton {
  width: 50%;
  float: left;
}
#bdpFilterPanel .bdp-filter-wrapper .p-field ::ng-deep .p-multiselect,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters ::ng-deep .p-multiselect {
  width: 100% !important; /* Ensure the component takes full width */
  max-width: 100% !important; /* Prevent overflow */
  box-sizing: border-box; /* Include padding/border in width */
}
#bdpFilterPanel .bdp-filter-wrapper .p-field ::ng-deep .p-multiselect-label,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters ::ng-deep .p-multiselect-label {
  color: #a8a8a8;
  font-size: 14px;
  white-space: normal !important; /* Allow placeholder text to wrap */
  padding: 8px !important; /* Add padding to prevent truncation */
  width: 100% !important; /* Ensure label takes full width */
  box-sizing: border-box; /* Prevent padding from causing overflow */
}
#bdpFilterPanel .bdp-filter-wrapper .p-field ::ng-deep .p-slider,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters ::ng-deep .p-slider {
  background-color: black;
}
#bdpFilterPanel .bdp-filter-wrapper .p-field ::ng-deep .p-slider .p-slider-range,
#bdpFilterPanel .bdp-filter-wrapper .bdp-visible-filters ::ng-deep .p-slider .p-slider-range {
  background-color: var(--bdpPrimaryLightBlue);
}
#bdpFilterPanel .bdp-filter-wrapper .bdp-date-filter {
  text-align: center;
}
#bdpFilterPanel .bdp-filter-wrapper .bdp-date-filter label {
  text-align: left;
  padding: 0;
  margin-bottom: 12px;
}
#bdpFilterPanel .smallInputField {
  width: 68px;
  text-align: center;
}
#bdpFilterPanel .setDefaultText {
  cursor: pointer;
  font-size: 1rem;
  text-decoration: underline;
  white-space: nowrap;
  padding: 10px;
}
#bdpFilterPanel .bdp-message-seperator {
  height: 29px;
  border-right: 2px solid #828282;
  margin-left: 24px;
}
#bdpFilterPanel .skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
#bdpFilterPanel .skeleton-item {
  width: 100%;
  height: 20px;
  background: linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite linear;
}
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media only screen and (max-width: 992px) {
  div.bdp-filter-panel {
    margin-top: 14vh;
  }
}
@media only screen and (min-width: 601px) {
  #bdpFilterPanel ::ng-deep .p-sidebar {
    width: 23rem !important;
    z-index: 10000 !important;
  }
}
::ng-deep .vessel-autocomplete .p-virtualscroller {
  max-height: 110px !important;
}

input.p-inputtext.p-component.ng-tns-c4208814996-14.ng-untouched.ng-pristine.ng-valid.p-filled {
  width: 100%;
}

h6.ng-tns-c999371001-14 {
  width: 101%;
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/filter-panel/filter-panel.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAEI;EACI,2CAAA;AAAR;AAGI;EACI,qBAAA;EACA,iCAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AADR;AAGQ;EACI,WAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;AADZ;AAIQ;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;AAFZ;AAKQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;AAHZ;AAMQ;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AAJZ;AAMY;EACI,yCAAA;EACA,YAAA;AAJhB;AASI;EA+II,2DAAA;EAqCA,0CAAA;EASA,6DAAA;AAjMR;AAKQ;EACI,kBAAA;AAHZ;AAMQ;EACI,8BAAA;AAJZ;AAOQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AALZ;AAOY;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AALhB;AAOgB;EACI,UAAA;EACA,WAAA;AALpB;AAOoB;EACI,gBAAA;EACA,WAAA;EACA,4CAAA;AALxB;AASgB;EACI,yBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAPpB;AAWY;EACI,WAAA;AAThB;AAWgB;EACI,YAAA;AATpB;AAWoB;EACI,aAAA;AATxB;AAegB;EACI,WAAA;EACA,YAAA;AAbpB;AAeoB;EACI,iBAAA;EACA,yBAAA;AAbxB;AAgBoB;EACI,kBAAA;AAdxB;AAgBwB;EACI,sBAAA;EACA,qBAAA;EACA,cAAA;AAd5B;AAmBgB;EACI,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;AAjBpB;AAmBoB;EACI,eAAA;EACA,qBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AAjBxB;AAmBwB;EACI,0CAAA;AAjB5B;AAoBwB;EACI,yBAAA;AAlB5B;AAoB4B;EACI,WAAA;AAlBhC;AAqB4B;EACI,WAAA;AAnBhC;AAuBwB;EACI,kBAAA;EACA,eAAA;AArB5B;AAwBwB;EACI,qBAAA;EACA,YAAA;EACA,WAAA;AAtB5B;AAyBwB;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAvB5B;AA4BgB;EACI,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA1BpB;AA4BoB;EACI,cAAA;EACA,0BAAA;EACA,eAAA;AA1BxB;AAiCQ;EACI,yBAAA,EAAA,2CAAA;EACA,0BAAA,EAAA,kCAAA;EACA,0BAAA,EAAA,iDAAA;EACA,mBAAA,EAAA,0CAAA;EACA,qBAAA,EAAA,yCAAA;EACA,oBAAA,EAAA,6BAAA;EACA,2BAAA,EAAA,uCAAA;EACA,yCAAA,EAAA,8BAAA;EACA,gBAAA,EAAA,qCAAA;AA/BZ;AAkCQ;EACI,4BAAA,EAAA,0BAAA;EACA,2BAAA,EAAA,oCAAA;EACA,sBAAA,EAAA,0BAAA;EACA,sBAAA,EAAA,gDAAA;AAhCZ;AAmCQ;EACI,qBAAA,EAAA,2BAAA;EACA,sBAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,gDAAA;AAjCZ;AAoCQ;EACI,8BAAA,EAAA,uBAAA;EACA,4BAAA,EAAA,gCAAA;EACA,0BAAA,EAAA,qBAAA;EACA,2BAAA,EAAA,yBAAA;EACA,+BAAA,EAAA,+BAAA;EACA,iCAAA,EAAA,qCAAA;EACA,sBAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,0CAAA;AAlCZ;AAsCQ;EACI,8BAAA,EAAA,mCAAA;EACA,uBAAA,EAAA,sCAAA;EACA,0BAAA,EAAA,oBAAA;EACA,sBAAA,EAAA,kCAAA;EACA,sBAAA,EAAA,0CAAA;AApCZ;AAwCQ;EACI,sBAAA,EAAA,0CAAA;EACA,0BAAA,EAAA,qBAAA;EACA,sBAAA,EAAA,oCAAA;AAtCZ;AAwCQ;EACI,8BAAA,EAAA,+BAAA;AAtCZ;AA0CI;EACI,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;EACA,YAAA;AAxCR;AA2CI;EACI,eAAA;EACA,iBAAA;AAzCR;AA2CQ;EACI,mBAAA;AAzCZ;AA6CI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AA3CR;AA6CQ;EACI,eAAA;AA3CZ;AA+CI;EACI,eAAA,EAAA,sDAAA;EACA,sBAAA,EAAA,wCAAA;AA7CR;AA+CQ;;EAEI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA,EAAA,+BAAA;EACA,sBAAA,EAAA,qBAAA;EACA,cAAA,EAAA,uCAAA;AA7CZ;AA+CY;;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA,EAAA,4BAAA;EACA,cAAA,EAAA,kCAAA;EACA,gBAAA,EAAA,wBAAA;EACA,WAAA,EAAA,kCAAA;EACA,sBAAA,EAAA,0CAAA;EACA,mBAAA,EAAA,+CAAA;AA5ChB;AAgDgB;;EACI,UAAA;EACA,WAAA;AA7CpB;AAiDY;;EACI,sBAAA,EAAA,0CAAA;EACA,0BAAA,EAAA,qBAAA;EACA,sBAAA,EAAA,oCAAA;AA9ChB;AAiDY;;EACI,cAAA;EACA,eAAA;EACA,8BAAA,EAAA,mCAAA;EACA,uBAAA,EAAA,sCAAA;EACA,sBAAA,EAAA,kCAAA;EACA,sBAAA,EAAA,0CAAA;AA9ChB;AAiDY;;EACI,uBAAA;AA9ChB;AAgDgB;;EACI,4CAAA;AA7CpB;AAkDQ;EACI,kBAAA;AAhDZ;AAkDY;EACI,gBAAA;EACA,UAAA;EACA,mBAAA;AAhDhB;AAqDI;EACI,WAAA;EACA,kBAAA;AAnDR;AAsDI;EACI,eAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;AApDR;AAuDI;EACI,YAAA;EACA,+BAAA;EACA,iBAAA;AArDR;AAwDI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAtDR;AAyDI;EACI,WAAA;EACA,YAAA;EACA,yEAAA;EAMA,0BAAA;EACA,gDAAA;AA5DR;AA+DI;EACI;IACI,2BAAA;EA7DV;EA+DM;IACI,4BAAA;EA7DV;AACF;;AAiEA;EACI;IACI,gBAAA;EA9DN;AACF;AAuEA;EAEQ;IACI,uBAAA;IACA,yBAAA;EAtEV;AACF;AA0EA;EACI,4BAAA;AAxEJ;;AA0EA;EACI,WAAA;AAvEJ;;AAyEA;EACI,WAAA;AAtEJ","sourcesContent":["#bdpFilterPanel {\n    .bdp-sticky-header {\n        position: sticky;\n        top: 42px;\n        z-index: 100;\n        background: #fff;\n        padding: 10px 0px;\n    }\n    ::ng-deep .custom-vertical-divider .p-divider.p-divider-vertical {\n        color: 1px solid rgb(14, 13, 13) !important;\n    }\n\n    .sidebar-header {\n        display: inline-block;\n        border-bottom: thin solid #a8a8a8;\n        padding-bottom: 20px;\n        margin-bottom: 12px;\n        color: #dcdcdc;\n        width: 100%;\n\n        h5 {\n            float: left;\n            margin: 0;\n            line-height: 2;\n            color: var(--bdpFontPrimary);\n            font-size: 16px;\n        }\n\n        .bdp-clear-filters {\n            display: block;\n            padding: 8px 0 0 10px;\n            font-size: 14px;\n            text-decoration: underline;\n            cursor: pointer;\n            float: right;\n        }\n\n        .bdp-filter-close {\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            float: right;\n            position: relative;\n            top: 5px;\n            color: var(--bdpButtonPrimary);\n            font-size: 23px;\n            cursor: pointer;\n        }\n\n        .sidebar-button {\n            float: right;\n            margin: 0px 15px;\n            position: relative;\n\n            ::ng-deep button {\n                background-color: var(--bdpButtonPrimary);\n                border: none;\n            }\n        }\n    }\n\n    ::ng-deep {\n        .p-sidebar-right {\n            overflow-y: scroll;\n        }\n\n        .p-sidebar-content {\n            overflow-y: initial !important;\n        }\n\n        .bdp-filter-options {\n            float: left;\n            width: 100%;\n            position: relative;\n            margin-bottom: 10px;\n            padding-top: 3px;\n\n            .bdp-ini-view {\n                float: left;\n                width: 100%;\n                margin-bottom: 15px;\n                display: inline-block;\n\n                .sidebar-button {\n                    width: 86%;\n                    float: left;\n\n                    button {\n                        background: #fff;\n                        color: #444;\n                        border-color: #4444;\n                    }\n                }\n\n                .bdp-setting-icon {\n                    padding: 5px 0px 5px 10px;\n                    font-size: 20px;\n                    float: right;\n                    cursor: pointer;\n                    color: #004ce1;\n                    font-weight: bold;\n                }\n            }\n\n            p-card {\n                float: left;\n\n                .p-card-body {\n                    padding: 0px;\n\n                    .p-card-content {\n                        padding: 1rem;\n                    }\n                }\n            }\n\n            .bdp-filter-view {\n                .sidebar-button {\n                    float: left;\n                    width: 123px;\n\n                    &.bdp-save-filter {\n                        margin-left: 10px;\n                        background-color: #2d74ff;\n                    }\n\n                    &.bdp-cancle {\n                        margin-right: 10px;\n\n                        button {\n                            background-color: #fff;\n                            border-color: #3e5172;\n                            color: #3e5172;\n                        }\n                    }\n                }\n\n                .bdp-saved-filter-list {\n                    padding: 0px 10px;\n                    list-style-type: none;\n                    display: inline-block;\n                    width: 100%;\n                    margin: 0px;\n\n                    li {\n                        margin: 5px 0px;\n                        display: inline-block;\n                        width: 100%;\n                        padding: 5px 5px 0px 5px;\n                        border-radius: 3px;\n\n                        &:hover {\n                            background-color: rgba(232, 241, 248, 0.7);\n                        }\n\n                        &.bdp-selected {\n                            background-color: #004ce1;\n\n                            span {\n                                color: #fff;\n                            }\n\n                            i {\n                                color: #fff;\n                            }\n                        }\n\n                        h6 {\n                            margin-bottom: 5px;\n                            font-size: 14px;\n                        }\n\n                        span {\n                            display: inline-block;\n                            width: 150px;\n                            color: #333;\n                        }\n\n                        i {\n                            float: right;\n                            cursor: pointer;\n                            padding: 5px;\n                            color: #333;\n                        }\n                    }\n                }\n\n                .bdp-filter-info {\n                    border-top: 2px solid #ccd;\n                    display: inline-block;\n                    padding: 5px;\n                    margin-top: 15px;\n                    color: #828282;\n                    text-align: center;\n\n                    a {\n                        color: #2d74ff;\n                        text-decoration: underline;\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n\n        /* Fix for p-multiSelect dropdown positioning and overlap */\n        .p-multiselect-panel {\n            z-index: 10002 !important; /* Ensure it appears above other elements */\n            min-width: 100% !important; /* Match the width of the parent */\n            max-width: 100% !important; /* Restrict to parent width to prevent overflow */\n            right: 0 !important; /* Align to the right edge of the parent */\n            left: auto !important; /* Prevent stretching across the screen */\n            top: 100% !important; /* Position below the input */\n            transform-origin: top right; /* Ensure proper dropdown positioning */\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* Add shadow for visibility */\n            overflow: hidden; /* Prevent content from overflowing */\n        }\n\n        .p-multiselect-items-wrapper {\n            max-height: 200px !important; /* Limit dropdown height */\n            overflow-y: auto !important; /* Enable scrolling for long lists */\n            width: 100% !important; /* Match the panel width */\n            box-sizing: border-box; /* Ensure padding/border are included in width */\n        }\n\n        .p-multiselect-items {\n            padding: 0 !important; /* Remove default padding */\n            width: 100% !important; /* Ensure items take full width */\n            box-sizing: border-box; /* Ensure padding/border are included in width */\n        }\n\n        .p-multiselect-item {\n            white-space: normal !important; /* Allow text to wrap */\n            padding: 8px 12px !important; /* Add padding for readability */\n            font-size: 14px !important; /* Adjust font size */\n            line-height: 1.5 !important; /* Improve line spacing */\n            text-transform: none !important; /* Remove uppercase transform */\n            word-break: break-word !important; /* Ensure long words break properly */\n            width: 100% !important; /* Ensure items take full width */\n            box-sizing: border-box; /* Prevent padding from causing overflow */\n        }\n\n        /* Fix for the p-multiSelect input label */\n        .p-multiselect-label {\n            white-space: normal !important; /* Allow placeholder text to wrap */\n            padding: 8px !important; /* Add padding to prevent truncation */\n            font-size: 14px !important; /* Match font size */\n            width: 100% !important; /* Ensure label takes full width */\n            box-sizing: border-box; /* Prevent padding from causing overflow */\n        }\n\n        /* Ensure the multiselect component itself doesn't overflow */\n        .p-multiselect {\n            width: 100% !important; /* Ensure the component takes full width */\n            max-width: 100% !important; /* Prevent overflow */\n            box-sizing: border-box; /* Include padding/border in width */\n        }\n        .p-multiselect-panel .p-multiselect-items .p-multiselect-option {\n            white-space: nowrap !important; /* Override the previous rule */\n        }\n    }\n\n    .bdp-separator {\n        width: 100%;\n        height: 0px;\n        margin: 20px 0px 0px 0px;\n        border-top: 1px solid #ccc;\n        padding: 0px;\n    }\n\n    .sidebar-cat-header {\n        font-size: 14px;\n        font-weight: bold;\n\n        h6 {\n            margin-bottom: 12px;\n        }\n    }\n\n    .bdp-clear-select {\n        position: absolute;\n        right: 28px;\n        top: 32px;\n        z-index: 1;\n        cursor: pointer;\n\n        i {\n            font-size: 11px;\n        }\n    }\n\n    .bdp-filter-wrapper {\n        padding: 0 10px; /* Add padding to ensure content stays within bounds */\n        box-sizing: border-box; /* Ensure padding is included in width */\n\n        .p-field,\n        .bdp-visible-filters {\n            position: relative;\n            float: left;\n            width: 100%;\n            display: block;\n            margin-bottom: 20px; /* Add spacing between fields */\n            box-sizing: border-box; /* Prevent overflow */\n            padding: 0 5px; /* Add padding to ensure content fits */\n\n            label {\n                color: #1d2125;\n                font-size: 14px;\n                margin-bottom: 8px;\n                white-space: normal !important; /* Ensure label text wraps */\n                display: block; /* Ensure label takes full width */\n                line-height: 1.5; /* Improve readability */\n                width: 100%; /* Ensure label takes full width */\n                box-sizing: border-box; /* Prevent padding from causing overflow */\n                padding-right: 10px; /* Add padding to ensure full text visibility */\n            }\n\n            .bdp-radio-group {\n                .p-field-radiobutton {\n                    width: 50%;\n                    float: left;\n                }\n            }\n\n            ::ng-deep .p-multiselect {\n                width: 100% !important; /* Ensure the component takes full width */\n                max-width: 100% !important; /* Prevent overflow */\n                box-sizing: border-box; /* Include padding/border in width */\n            }\n\n            ::ng-deep .p-multiselect-label {\n                color: #a8a8a8;\n                font-size: 14px;\n                white-space: normal !important; /* Allow placeholder text to wrap */\n                padding: 8px !important; /* Add padding to prevent truncation */\n                width: 100% !important; /* Ensure label takes full width */\n                box-sizing: border-box; /* Prevent padding from causing overflow */\n            }\n\n            ::ng-deep .p-slider {\n                background-color: black;\n\n                .p-slider-range {\n                    background-color: var(--bdpPrimaryLightBlue);\n                }\n            }\n        }\n\n        .bdp-date-filter {\n            text-align: center;\n\n            label {\n                text-align: left;\n                padding: 0;\n                margin-bottom: 12px;\n            }\n        }\n    }\n\n    .smallInputField {\n        width: 68px;\n        text-align: center;\n    }\n\n    .setDefaultText {\n        cursor: pointer;\n        font-size: 1rem;\n        text-decoration: underline;\n        white-space: nowrap;\n        padding: 10px;\n    }\n\n    .bdp-message-seperator {\n        height: 29px;\n        border-right: 2px solid #828282;\n        margin-left: 24px;\n    }\n\n    .skeleton-loader {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n    }\n\n    .skeleton-item {\n        width: 100%;\n        height: 20px;\n        background: linear-gradient(\n            90deg,\n            #f3f3f3 25%,\n            #e0e0e0 50%,\n            #f3f3f3 75%\n        );\n        background-size: 200% 100%;\n        animation: skeleton-loading 1.5s infinite linear;\n    }\n\n    @keyframes skeleton-loading {\n        0% {\n            background-position: 200% 0;\n        }\n        100% {\n            background-position: -200% 0;\n        }\n    }\n}\n\n@media only screen and (max-width: 992px) {\n    div.bdp-filter-panel {\n        margin-top: 14vh;\n    }\n}\n\n@media only screen and (min-width: 993px) {\n    div.bdp-filter-panel {\n        // margin-top: 6vh;\n    }\n}\n\n@media only screen and (min-width: 601px) {\n    #bdpFilterPanel {\n        ::ng-deep .p-sidebar {\n            width: 23rem !important;\n            z-index: 10000 !important;\n        }\n    }\n}\n\n::ng-deep .vessel-autocomplete .p-virtualscroller {\n    max-height: 110px !important;\n}\ninput.p-inputtext.p-component.ng-tns-c4208814996-14.ng-untouched.ng-pristine.ng-valid.p-filled {\n    width: 100%;\n}\nh6.ng-tns-c999371001-14 {\n    width: 101%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
